var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlackLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6084_7665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0525 63.1578C21.0525 68.9707 16.3391 73.6842 10.5262 73.6842C4.71348 73.6842 0 68.9707 0 63.1578C0 57.3449 4.71348 52.6314 10.5264 52.6314H21.0527V63.1578H21.0525Z",
    fill: "#FF185B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3164 63.1578C26.3164 57.3449 31.0299 52.6314 36.8428 52.6314C42.6557 52.6314 47.3691 57.3449 47.3691 63.1578V89.4736C47.3691 95.2865 42.6557 100 36.8428 100C31.0299 100 26.3164 95.2865 26.3164 89.4736V63.1578Z",
    fill: "#FF185B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8428 21.0525C31.0299 21.0525 26.3164 16.3391 26.3164 10.5262C26.3164 4.71348 31.0299 0 36.8428 0C42.6557 0 47.3691 4.71348 47.3691 10.5264V21.0527H36.8428V21.0525Z",
    fill: "#00C5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8422 26.3158C42.6551 26.3158 47.3685 31.0293 47.3685 36.8422C47.3685 42.6551 42.6551 47.3686 36.8422 47.3686H10.5264C4.71348 47.3684 0 42.6549 0 36.8422C0 31.0295 4.71348 26.3158 10.5264 26.3158H36.8422Z",
    fill: "#00C5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9492 36.8422C78.9492 31.0293 83.6627 26.3158 89.4756 26.3158C95.2885 26.3158 100.002 31.0293 100.002 36.8422C100.002 42.6551 95.2885 47.3686 89.4756 47.3686H78.9492V36.8422Z",
    fill: "#00B67B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6855 36.8422C73.6855 42.6551 68.9721 47.3685 63.1592 47.3685C57.3463 47.3685 52.6328 42.6551 52.6328 36.8422V10.5264C52.633 4.71348 57.3465 0 63.1592 0C68.9719 0 73.6855 4.71348 73.6855 10.5264V36.8422Z",
    fill: "#00B67B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1592 78.9474C68.9721 78.9474 73.6855 83.6609 73.6855 89.4738C73.6855 95.2867 68.9721 100 63.1592 100C57.3463 100 52.6328 95.2867 52.6328 89.4738V78.9474H63.1592Z",
    fill: "#FFB20F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1592 73.6842C57.3463 73.6842 52.6328 68.9707 52.6328 63.1578C52.6328 57.3449 57.3463 52.6314 63.1592 52.6314H89.475C95.2879 52.6314 100.001 57.3449 100.001 63.1578C100.001 68.9707 95.2879 73.6842 89.475 73.6842H63.1592Z",
    fill: "#FFB20F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6084_7665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackLogo);
export default __webpack_public_path__ + "static/media/slack-logo.66cb4b078fe8a9919f8368ced514b610.svg";
export { ForwardRef as ReactComponent };